import api from '@/configurations/service';
import * as types from './mutation-types';

export const resetServiceTributesState = async (context) => {
  context.commit(types.RESET_SERVICE_TRIBUTES);
};

export const deleteServiceTributes = async (context, id) => {
  const { data } = await api().post('consumers.delete-service-tributes', { id });

  context.commit(types.SET_TRIBUTES_WARNINGS, data.warnings);
};

export const saveServiceTributes = async (_, payload) => {
  const { id } = payload;

  if (!id) {
    await api().post('consumers.register-service-tributes', payload);
    return;
  }

  await api().post('consumers.update-service-tributes', payload);
};

export const setSummaryServiceTributes = async (context, { search, pagination }) => {
  const body = { search, pagination };
  const { data } = await api().post('consumers.find-summary-service-tributes', body);

  context.commit(types.SET_PAGINATION_SERVICE_TRIBUTES, data.pagination);
  context.commit(types.SET_SUMMARY_SERVICE_TRIBUTES, data.data);
};

export const setDetailedServiceTributes = async (context, id) => {
  const { data } = await api().post('consumers.find-detailed-service-tributes', { id });

  context.commit(types.SET_DETAILED_SERVICE_TRIBUTES, data);
};
